import JsonView from '@uiw/react-json-view';

type JsonBlockProperties = {
  collapsed?: number;
  value: unknown;
};

const normalizeJsonValue = (value: unknown): object => {
  if (value && typeof value === 'object') {
    return value;
  }
  return { value };
};

export const JsonBlock = ({ collapsed = 2, value }: JsonBlockProperties) => (
  <div className="border-line bg-raised max-w-full min-w-0 overflow-auto rounded-md border p-3">
    <JsonView collapsed={collapsed} value={normalizeJsonValue(value)} />
  </div>
);

export const CodeBlock = ({ value }: { value: string }) => (
  <pre className="technical border-ink bg-ink text-canvas overflow-auto rounded-md border p-3 text-xs">
    <code>{value}</code>
  </pre>
);
